export default "__VITE_ASSET__vB5uG2lQ__"